import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs';
import * as moment from 'moment';
import {ClientService} from "./client.service";
import {AdminService} from "./admin.service";
import {AlertMessage} from "../directives/AlertMessage";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class AlertService {
    private _subject = new Subject<any>();
    private keepAfterNavigationChange = false;

    // private _router : Router;
    // private _session: SessionService;
    private _clientService: ClientService;
    private _adminService: AdminService;
    private id: number;

    constructor() {
        // clear alert message on route change
      this.id = moment().unix();
      this._subject.next('Init...');
      console.log('Creating AlertService ' + this.id);
    }

    /*
    public set router(bean: Router){
      console.log(this.id  +' Somebody setup the router to be: ' + bean);
      this._router = bean;
      this._router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (this.keepAfterNavigationChange) {
            // only keep for a single location change
            this.keepAfterNavigationChange = false;
          } else {
            // clear alert
            this.subject.next();
          }
        }
      });
    }

    public set session(bean: SessionService){
      this._session = bean;
    }
    public get session(): SessionService{
      return this._session;
    }

    public get router(): Router {
      return this._router;
    }
    */
    public set clientService(bean: ClientService){
      this._clientService = bean;
    }
    public get clientService(): ClientService{
      return this._clientService;
    }

    public set adminService(bean: AdminService){
      this._adminService = bean;
    }
    public get adminService(): AdminService{
      return this._adminService;
    }


  success(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this._subject.next({ type: 'success', text: message });
    }


    warning(message: string, keepAfterNavigationChange = false) {
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this._subject.next({ type: 'warning', text: message });
    }

  newChat(alertMessage: AlertMessage){
    console.log('Alert Service pushing chat message!',alertMessage);
    this._subject.next(alertMessage);
  }


  clear() {
      this._subject.next(null);
    }

    // error(message: string, keepAfterNavigationChange = false) {
    //     console.log('Adding error message: ' + message);
    //     this.keepAfterNavigationChange = keepAfterNavigationChange;
    //     this.subject.next({ type: 'error', text: message });
    // }

    error(message: string, errorCode: any) {
      // console.log('Adding error message: ' + message);
      // this.keepAfterNavigationChange = keepAfterNavigationChange;


      this._subject.next({ type: 'error', text: message });
      if (errorCode === 141414) {
        console.log(this.id  +' Session has been lost.');
        setTimeout(()=>{
          console.log(this.id  +' Session has been lost. Leaving...');
          this.dismissAllModals();
          if (this._clientService){
            this.clientService.logout();
          }
          if (this._adminService){
            this.adminService.logout();
          }
          // this._session.close();
          // this._router.navigate(['/']);
      },1000);
        // setTimeout( function(){
        //   console.log(this.id  +' Session has been lost. Leaving...');
        //   this._router.navigate(['/']);
        // }, 1000 );
      }
    }

    allModals = new Array<NgbModalRef>();
    registerModal(modalRef: NgbModalRef) {
      this.allModals.push(modalRef);
    }

    dismissAllModals(){
      for (const modal of this.allModals){
        if (modal){
          modal.dismiss();
        }
      }
    }

    public get subject(){
      return this._subject;
    }


  getMessage(): Observable<any> {

    // console.log('Somebody asked for the subjet.asObservable');
        return this._subject.asObservable();
    }
}
